import citiesDataJson from "../../cities/cities.json";

const citiesData: Record<string, string> = citiesDataJson;

export class TextValidator {
  // Mapa invertido: nombre => código
  static readonly dataCitiesName: Record<string, string> =
    TextValidator.createReversedMap();

  static readonly citiesName: string[] = Object.keys(
    TextValidator.dataCitiesName
  );

  // Método privado para generar el reversedMap
  private static createReversedMap(): Record<string, string> {
    const result: Record<string, string> = {};
    for (const key in citiesData) {
      result[citiesData[key].toUpperCase()] = key;
    }
    // console.log(result);
    return result;
  }

  static getCodeByCityName(name: string): string | undefined {
    return this.dataCitiesName[name];
  }

  static getSuggestion(name: string) {
    let suggestion = "";
    let puto = 0;
    let filteS = this.citiesName.filter((value) => value[0] == name[0]);
    //console.log(filteS);
    for (let i = 0; i < filteS.length; i++) {
      let valueC = this.conside(name, filteS[i]);
      if (puto < valueC) {
        suggestion = filteS[i];
        puto = valueC;
      }
    }
    return suggestion;
  }

  static conside(name: string, city: string) {
    //console.log(name, "::", city);
    let cocide = 0;
    for (let i = 0; i < name.length; i++) {
      if (name[i] === city[i]) {
        cocide++;
      }
    }
    //console.log(cocide);
    return cocide;
  }
}
